__turbopack_context__.v({
  "container": "DA952q_container",
  "slide-in": "DA952q_slide-in",
  "toast": "DA952q_toast",
});
